import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { BiSearch } from 'react-icons/bi'; // use react-icons for clean look
import './style.css'; // We'll write custom styles
import { useThemeMode } from '../../../context/contextTheme';

const Searchbar = ({ onSearch }) => {
  const { theme } = useThemeMode();
  const [query, setQuery] = useState('');
  const [isHovered, setIsHovered] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch && onSearch(query.trim());
  };

  return (
    <>
      <Form onSubmit={handleSubmit} className="custom-searchbar d-flex align-items-center"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          border: isHovered ? `1px solid ${theme.borderHover2}` : `1px solid ${theme.border}`,
          backgroundColor: theme.background,        
        }}>
        <BiSearch className="search-icon" />
        <input
          type="text"
          className="search-input"
          placeholder="Search..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          style={{ 
            color: theme.textColor,
            
          }}
        />
      </Form>
      <style>{`
        .search-input::placeholder {
          color: ${theme.textMuted};
        }
        .search-icon {
          color: ${theme.textMuted};
        }
      `}</style>
    </>
  );
};

export default Searchbar;